import MainPage from "./pages/MainPage";
import AbooutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import WorkWidthUs from "./pages/WorkWidthUS";
import DriverApps from "./pages/DriverApps";
import RepairApps from "./pages/RepairApps";
import Faq from "./pages/Faq";
import Privacy from "./pages/Privacy";
import { Navigate } from "react-router-dom";
import Channels from "./pages/Channels";
import Address from "./pages/Address";
import PaymentCallBack from "./pages/PaymentCallBack";

let routes = [
  { path: "/", element: <MainPage /> },
  { path: "/aboutUs", element: <AbooutUs /> },
  { path: "/contactUs", element: <ContactUs /> },
  { path: "/contactUs/address", element: <Address /> },
  { path: "/workWidthUs", element: <WorkWidthUs /> },
  { path: "/links/app", element: <DriverApps /> },
  { path: "/links/channel", element: <Channels /> },
  { path: "/repair/links/app", element: <RepairApps /> },
  { path: "/faq", element: <Faq /> },
  { path: "/privacy", element: <Privacy /> },
  // { path: "/payment", element: <PaymentCallBack /> },
  // { path: "/repair-tutorial", element: <RepairTutorial /> },
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

export default routes;
